// AUTO-GENERATED by pipeline/export_engine_data.py - do not edit by hand.
// Source of truth: pipeline/recommend.py + pipeline/products.py
const ENGINE_DATA = {
  "ZERO_TOLERANCE": {
    "arsenic": {
      "system": "arsenic",
      "name": "Arsenic"
    },
    "lead": {
      "system": "lead",
      "name": "Lead"
    },
    "mercury": {
      "system": "mercury",
      "name": "Mercury"
    },
    "chromium6": {
      "system": "chromium6",
      "name": "Hexavalent Chromium"
    },
    "uranium": {
      "system": "uranium",
      "name": "Uranium"
    },
    "uranium238": {
      "system": "uranium",
      "name": "Uranium-238"
    },
    "radium_combined": {
      "system": "radium",
      "name": "Radium (combined)"
    },
    "radium226": {
      "system": "radium",
      "name": "Radium-226"
    },
    "radium228": {
      "system": "radium",
      "name": "Radium-228"
    },
    "radon": {
      "system": "radon",
      "name": "Radon"
    },
    "pfoa": {
      "system": "pfas",
      "name": "PFOA"
    },
    "pfos": {
      "system": "pfas",
      "name": "PFOS"
    },
    "pfna": {
      "system": "pfas",
      "name": "PFNA"
    },
    "pfhxs": {
      "system": "pfas",
      "name": "PFHxS"
    },
    "genx": {
      "system": "pfas",
      "name": "GenX"
    },
    "pfbs": {
      "system": "pfas",
      "name": "PFBS"
    },
    "hazard_index_pfas": {
      "system": "pfas",
      "name": "PFAS Hazard Index"
    },
    "pfba": {
      "system": "pfas",
      "name": "PFBA"
    },
    "pfhxa": {
      "system": "pfas",
      "name": "PFHxA"
    },
    "pfpea": {
      "system": "pfas",
      "name": "PFPeA"
    },
    "pfpes": {
      "system": "pfas",
      "name": "PFPeS"
    },
    "pfhpa": {
      "system": "pfas",
      "name": "PFHpA"
    },
    "pfhps": {
      "system": "pfas",
      "name": "PFHpS"
    },
    "pfda": {
      "system": "pfas",
      "name": "PFDA"
    },
    "pfdoa": {
      "system": "pfas",
      "name": "PFDoA"
    },
    "pfuna": {
      "system": "pfas",
      "name": "PFUnA"
    },
    "pftrda": {
      "system": "pfas",
      "name": "PFTrDA"
    },
    "pfteda": {
      "system": "pfas",
      "name": "PFTA"
    },
    "adona": {
      "system": "pfas",
      "name": "ADONA"
    },
    "nfdha": {
      "system": "pfas",
      "name": "NFDHA"
    },
    "pfmba": {
      "system": "pfas",
      "name": "PFMBA"
    },
    "pfmpa": {
      "system": "pfas",
      "name": "PFMPA"
    },
    "pfeesa": {
      "system": "pfas",
      "name": "PFEESA"
    },
    "pfns": {
      "system": "pfas",
      "name": "PFNS"
    },
    "netfosaa": {
      "system": "pfas",
      "name": "NEtFOSAA"
    },
    "nmefosaa": {
      "system": "pfas",
      "name": "NMeFOSAA"
    },
    "62fts": {
      "system": "pfas",
      "name": "6:2 FTS"
    },
    "82fts": {
      "system": "pfas",
      "name": "8:2 FTS"
    },
    "42fts": {
      "system": "pfas",
      "name": "4:2 FTS"
    },
    "pf3ons_9cl": {
      "system": "pfas",
      "name": "9Cl-PF3ONS"
    },
    "11cl_pf3ouds": {
      "system": "pfas",
      "name": "11Cl-PF3OUdS"
    }
  },
  "ZT_FLOORS": {
    "lead": {
      "v": 0.0075,
      "kind": "mass"
    },
    "arsenic": {
      "v": 0.005,
      "kind": "mass"
    },
    "mercury": {
      "v": 0.001,
      "kind": "mass"
    },
    "chromium6": {
      "v": 0.005,
      "kind": "mass"
    },
    "uranium": {
      "v": 0.015,
      "kind": "mass",
      "alt_v": 10.0,
      "alt_kind": "activity"
    },
    "uranium238": {
      "v": 10.0,
      "kind": "activity"
    },
    "radium_combined": {
      "v": 2.5,
      "kind": "activity"
    },
    "radium226": {
      "v": 2.5,
      "kind": "activity"
    },
    "radium228": {
      "v": 2.5,
      "kind": "activity"
    },
    "pfoa": {
      "v": 2e-06,
      "kind": "mass"
    },
    "pfos": {
      "v": 2e-06,
      "kind": "mass"
    },
    "pfna": {
      "v": 5e-06,
      "kind": "mass"
    },
    "pfhxs": {
      "v": 5e-06,
      "kind": "mass"
    },
    "genx": {
      "v": 5e-06,
      "kind": "mass"
    },
    "pfbs": {
      "v": 0.001,
      "kind": "mass"
    },
    "hazard_index_pfas": {
      "v": 0.5,
      "kind": "index"
    },
    "pfba": {
      "v": 9.9e-06,
      "kind": "mass"
    },
    "pfhxa": {
      "v": 9.9e-06,
      "kind": "mass"
    },
    "pfpea": {
      "v": 9.9e-06,
      "kind": "mass"
    },
    "pfpes": {
      "v": 9.9e-06,
      "kind": "mass"
    },
    "pfhpa": {
      "v": 9.9e-06,
      "kind": "mass"
    },
    "pfhps": {
      "v": 9.9e-06,
      "kind": "mass"
    },
    "pfda": {
      "v": 9.9e-06,
      "kind": "mass"
    },
    "pfdoa": {
      "v": 9.9e-06,
      "kind": "mass"
    },
    "pfuna": {
      "v": 9.9e-06,
      "kind": "mass"
    },
    "pftrda": {
      "v": 9.9e-06,
      "kind": "mass"
    },
    "pfteda": {
      "v": 9.9e-06,
      "kind": "mass"
    },
    "adona": {
      "v": 9.9e-06,
      "kind": "mass"
    },
    "nfdha": {
      "v": 9.9e-06,
      "kind": "mass"
    }
  },
  "THRESHOLDS": {
    "iron": {
      "threshold": 0.3,
      "system": "metal",
      "name": "Iron"
    },
    "manganese": {
      "threshold": 0.05,
      "system": "metal",
      "name": "Manganese"
    },
    "copper": {
      "threshold": 0.5,
      "system": "metal_ro",
      "name": "Copper"
    },
    "zinc": {
      "threshold": 5,
      "system": "metal_ro",
      "name": "Zinc"
    },
    "nickel": {
      "threshold": 0.05,
      "system": "metal_ro",
      "name": "Nickel"
    },
    "chromium": {
      "threshold": 0.05,
      "system": "metal_ro",
      "name": "Total Chromium"
    },
    "hardness": {
      "threshold": 3,
      "system": "softener",
      "name": "Hardness",
      "kind": "hardness"
    },
    "hardness_magnesium": {
      "threshold": 30,
      "system": "softener",
      "name": "Magnesium",
      "kind": "mineral"
    },
    "ph": {
      "threshold_low": 6.5,
      "threshold_high": 8.5,
      "system": "ph",
      "name": "pH",
      "kind": "ph"
    },
    "tds": {
      "threshold": 300,
      "system": "tds",
      "name": "TDS"
    },
    "nitrate": {
      "threshold": 5,
      "system": "nitrate",
      "name": "Nitrate"
    },
    "nitrite": {
      "threshold": 0.5,
      "system": "nitrate",
      "name": "Nitrite"
    },
    "nitrite_n": {
      "threshold": 0.5,
      "system": "nitrate",
      "name": "Nitrite (as N)"
    },
    "fluoride": {
      "threshold": 2.0,
      "system": "fluoride",
      "name": "Fluoride",
      "any_detection": false
    },
    "sulfate": {
      "threshold": 200,
      "system": "sulfate",
      "name": "Sulfate"
    },
    "tthm": {
      "threshold": 0.04,
      "system": "dbp",
      "name": "TTHMs"
    },
    "haa5": {
      "threshold": 0.03,
      "system": "dbp",
      "name": "HAA5"
    },
    "chloroform": {
      "threshold": 0.002,
      "system": "dbp",
      "name": "Chloroform"
    },
    "bromodichloromethane": {
      "threshold": 0.002,
      "system": "dbp",
      "name": "Bromodichloromethane"
    },
    "dibromochloromethane": {
      "threshold": 0.002,
      "system": "dbp",
      "name": "Dibromochloromethane"
    },
    "bromoform": {
      "threshold": 0.002,
      "system": "dbp",
      "name": "Bromoform"
    },
    "dichloroacetic_acid": {
      "threshold": 0.001,
      "system": "dbp",
      "name": "Dichloroacetic Acid"
    },
    "trichloroacetic_acid": {
      "threshold": 0.001,
      "system": "dbp",
      "name": "Trichloroacetic Acid"
    },
    "monobromoacetic_acid": {
      "threshold": 0.001,
      "system": "dbp",
      "name": "Monobromoacetic Acid"
    },
    "dibromoacetic_acid": {
      "threshold": 0.001,
      "system": "dbp",
      "name": "Dibromoacetic Acid"
    },
    "monochloroacetic_acid": {
      "threshold": 0.001,
      "system": "dbp",
      "name": "Monochloroacetic Acid"
    },
    "haa9": {
      "threshold": 0.03,
      "system": "dbp",
      "name": "HAA9"
    },
    "haa6br": {
      "threshold": 0.03,
      "system": "dbp",
      "name": "HAA6Br"
    },
    "strontium": {
      "threshold": 1.5,
      "system": "strontium",
      "name": "Strontium"
    },
    "barium": {
      "threshold": 1,
      "system": "barium",
      "name": "Barium"
    },
    "selenium": {
      "threshold": 0.025,
      "system": "selenium",
      "name": "Selenium"
    },
    "cadmium": {
      "threshold": 0.003,
      "system": "cadmium",
      "name": "Cadmium"
    },
    "antimony": {
      "threshold": 0.004,
      "system": "antimony",
      "name": "Antimony"
    },
    "beryllium": {
      "threshold": 0.002,
      "system": "beryllium",
      "name": "Beryllium"
    },
    "thallium": {
      "threshold": 0.001,
      "system": "thallium",
      "name": "Thallium"
    },
    "cyanide": {
      "threshold": 0.1,
      "system": "cyanide",
      "name": "Cyanide"
    },
    "gross_alpha": {
      "threshold": 10,
      "system": "radioactive",
      "name": "Gross Alpha",
      "kind": "radio"
    },
    "gross_alpha_incl": {
      "threshold": 10,
      "system": "radioactive",
      "name": "Gross Alpha (incl. U)",
      "kind": "radio"
    },
    "gross_beta": {
      "threshold": 30,
      "system": "radioactive",
      "name": "Gross Beta",
      "kind": "radio"
    },
    "strontium90": {
      "threshold": 8,
      "system": "radioactive",
      "name": "Strontium-90",
      "kind": "radio"
    },
    "sodium": {
      "threshold": 30,
      "system": "sodium",
      "name": "Sodium"
    },
    "chloride": {
      "threshold": 200,
      "system": "chloride",
      "name": "Chloride"
    },
    "silica": {
      "threshold": 10,
      "system": "silica",
      "name": "Silica"
    },
    "tannins": {
      "threshold": 0,
      "system": "tannin",
      "name": "Tannins",
      "any_detection": true
    },
    "h2s": {
      "threshold": 0,
      "system": "metal",
      "name": "Hydrogen Sulfide",
      "any_detection": true
    },
    "calcium": {
      "threshold": 50,
      "system": "softener",
      "name": "Calcium",
      "kind": "mineral"
    },
    "turbidity": {
      "threshold": 0.5,
      "system": "turbidity",
      "name": "Turbidity",
      "kind": "turbidity"
    },
    "chlorine": {
      "threshold": 0.5,
      "system": "chlorine",
      "name": "Free Chlorine"
    },
    "chlorine_total": {
      "threshold": 0.5,
      "system": "chlorine",
      "name": "Total Chlorine"
    },
    "chloramine": {
      "threshold": 0.5,
      "system": "chloramine",
      "name": "Chloramine"
    },
    "bromate": {
      "threshold": 0.005,
      "system": "dbp",
      "name": "Bromate"
    },
    "chlorite": {
      "threshold": 0.8,
      "system": "dbp",
      "name": "Chlorite"
    },
    "aluminum": {
      "threshold": 0.1,
      "system": "metal_ro",
      "name": "Aluminum"
    },
    "perchlorate": {
      "threshold": 0.004,
      "system": "perchlorate",
      "name": "Perchlorate"
    },
    "benzene": {
      "threshold": 0.0025,
      "system": "voc",
      "name": "Benzene"
    },
    "tce": {
      "threshold": 0.0025,
      "system": "voc",
      "name": "Trichloroethylene (TCE)"
    },
    "pce": {
      "threshold": 0.0025,
      "system": "voc",
      "name": "Tetrachloroethylene (PCE)"
    },
    "carbon_tet": {
      "threshold": 0.0025,
      "system": "voc",
      "name": "Carbon Tetrachloride"
    },
    "dichloromethane": {
      "threshold": 0.0025,
      "system": "voc",
      "name": "Dichloromethane"
    },
    "toluene": {
      "threshold": 0.5,
      "system": "voc",
      "name": "Toluene"
    },
    "ethylbenzene": {
      "threshold": 0.35,
      "system": "voc",
      "name": "Ethylbenzene"
    },
    "styrene": {
      "threshold": 0.05,
      "system": "voc",
      "name": "Styrene"
    },
    "xylenes": {
      "threshold": 5.0,
      "system": "voc",
      "name": "Xylenes (total)"
    },
    "12dca": {
      "threshold": 0.0025,
      "system": "voc",
      "name": "1,2-Dichloroethane"
    },
    "11dce": {
      "threshold": 0.0035,
      "system": "voc",
      "name": "1,1-Dichloroethylene"
    },
    "cis12dce": {
      "threshold": 0.035,
      "system": "voc",
      "name": "cis-1,2-Dichloroethylene"
    },
    "trans12dce": {
      "threshold": 0.05,
      "system": "voc",
      "name": "trans-1,2-Dichloroethylene"
    },
    "12dcp": {
      "threshold": 0.0025,
      "system": "voc",
      "name": "1,2-Dichloropropane"
    },
    "111tca": {
      "threshold": 0.1,
      "system": "voc",
      "name": "1,1,1-Trichloroethane"
    },
    "112tca": {
      "threshold": 0.0025,
      "system": "voc",
      "name": "1,1,2-Trichloroethane"
    },
    "pdcb": {
      "threshold": 0.0375,
      "system": "voc",
      "name": "p-Dichlorobenzene"
    },
    "odcb": {
      "threshold": 0.3,
      "system": "voc",
      "name": "o-Dichlorobenzene"
    },
    "124tcb": {
      "threshold": 0.035,
      "system": "voc",
      "name": "1,2,4-Trichlorobenzene"
    },
    "chlorobenzene": {
      "threshold": 0.05,
      "system": "voc",
      "name": "Chlorobenzene"
    },
    "deha": {
      "threshold": 0.2,
      "system": "voc",
      "name": "DEHA"
    },
    "dehp": {
      "threshold": 0.003,
      "system": "voc",
      "name": "DEHP"
    },
    "pcb_aroclor": {
      "threshold": 0.00025,
      "system": "voc",
      "name": "PCBs"
    },
    "dioxin_tcdd": {
      "threshold": 1.5e-08,
      "system": "voc",
      "name": "2,3,7,8-TCDD (Dioxin)"
    },
    "atrazine": {
      "threshold": 0.0015,
      "system": "voc",
      "name": "Atrazine"
    },
    "simazine": {
      "threshold": 0.002,
      "system": "voc",
      "name": "Simazine"
    },
    "24d": {
      "threshold": 0.035,
      "system": "voc",
      "name": "2,4-D"
    },
    "dalapon": {
      "threshold": 0.1,
      "system": "voc",
      "name": "Dalapon"
    },
    "picloram": {
      "threshold": 0.25,
      "system": "voc",
      "name": "Picloram"
    },
    "hexachlorobenzene": {
      "threshold": 0.0005,
      "system": "voc",
      "name": "Hexachlorobenzene"
    },
    "245tp": {
      "threshold": 0.025,
      "system": "voc",
      "name": "2,4,5-TP (Silvex)"
    },
    "lindane": {
      "threshold": 0.0001,
      "system": "voc",
      "name": "Lindane"
    },
    "alachlor": {
      "threshold": 0.001,
      "system": "voc",
      "name": "Alachlor"
    },
    "endothall": {
      "threshold": 0.05,
      "system": "voc",
      "name": "Endothall"
    }
  },
  "SPECIALTY_MAP": {
    "arsenic": "Arsenic Removal System",
    "lead": "Lead Removal System",
    "mercury": "Mercury Removal System",
    "chromium6": "Hexavalent Chromium Removal",
    "uranium": "Uranium/Radium Removal",
    "radium": "Uranium/Radium Removal",
    "radioactive": "Radionuclide Removal System",
    "radon": "Radon Reduction (GAC)",
    "nitrate": "Nitrate Removal System",
    "fluoride": "Fluoride Removal System",
    "sulfate": "Sulfate Removal System",
    "strontium": "Strontium Removal System",
    "barium": "Barium Removal System",
    "selenium": "Selenium Removal System",
    "cadmium": "Cadmium Removal System",
    "antimony": "Antimony Removal System",
    "beryllium": "Beryllium Removal System",
    "thallium": "Thallium Removal System",
    "cyanide": "Cyanide Removal System",
    "tannin": "Tannin Removal System",
    "turbidity": "Turbidity/Sediment Filter",
    "perchlorate": "Perchlorate Removal",
    "silica": "Silica Treatment System",
    "tds": "TDS Reduction System",
    "sodium": "Sodium Reduction (RO Required)",
    "chloride": "Chloride Reduction (RO Required)"
  },
  "SPECIALTY_SYSTEMS": [
    "arsenic",
    "lead",
    "mercury",
    "chromium6",
    "uranium",
    "radium",
    "pfas",
    "nitrate",
    "fluoride",
    "sulfate",
    "strontium",
    "barium",
    "selenium",
    "perchlorate",
    "cadmium",
    "antimony",
    "beryllium",
    "thallium",
    "cyanide",
    "radioactive"
  ],
  "RO_PREFERRED_SYSTEMS": [
    "antimony",
    "barium",
    "beryllium",
    "cadmium",
    "chromium6",
    "cyanide",
    "mercury",
    "metal_ro",
    "perchlorate",
    "radioactive",
    "radium",
    "selenium",
    "thallium"
  ],
  "PRODUCT_MAP": {
    "Sediment Pre-Filter": {
      "collection": "Sediment Pre-Filtration",
      "product": {
        "name": "Pleated Cellulose Sediment Cartridge",
        "url": "https://crystalquest.com/products/sediment-reusable-pleated-filter-cartridge"
      }
    },
    "Carbon Post-Filter": {
      "collection": "Granular Activated Carbon",
      "product": {
        "name": "GAC Water Filtration System",
        "url": "https://crystalquest.com/products/gac-water-filtration-system"
      }
    },
    "Built-In Prefilters (Sediment + Carbon Block + SMART)": {
      "collection": "Reverse Osmosis Systems",
      "product": null
    },
    "SMART Whole House Filter": {
      "collection": "Whole House Filters - SMART",
      "product": {
        "name": "SMART Whole House Water Filter (9-13 GPM)",
        "url": "https://crystalquest.com/products/smart-whole-house-water-filter"
      }
    },
    "Eagle Whole House Filter": {
      "collection": "Whole House Filters - Eagle (Alkalizing)",
      "product": {
        "name": "Eagle Whole House Water Filter",
        "url": "https://crystalquest.com/products/eagle-whole-house-water-filter"
      }
    },
    "Guardian Whole House Filter": {
      "collection": "Whole House Filters - Guardian (Budget)",
      "product": {
        "name": "Guardian Whole House Water Filter",
        "url": "https://crystalquest.com/products/whole-house-water-filter-guardian"
      }
    },
    "Iron/Manganese/Sulfur Removal": {
      "collection": "Iron / Manganese / Sulfur Removal",
      "product": {
        "name": "Metal Removal Whole House Water Filter",
        "url": "https://crystalquest.com/products/iron-whole-house-water-filter"
      }
    },
    "Iron/Metal Removal System (RO Pre-Treatment)": {
      "collection": "Iron / Manganese / Sulfur Removal",
      "product": {
        "name": "Metal Removal Whole House Water Filter",
        "url": "https://crystalquest.com/products/iron-whole-house-water-filter"
      }
    },
    "Water Softener": {
      "collection": "Water Softeners",
      "product": {
        "name": "Whole House Water Softener with Pre/Post Filtration",
        "url": "https://crystalquest.com/products/whole-house-water-softener"
      }
    },
    "Water Softener (RO Pre-Treatment)": {
      "collection": "Water Softeners",
      "product": {
        "name": "Whole House Water Softener with Pre/Post Filtration",
        "url": "https://crystalquest.com/products/whole-house-water-softener"
      }
    },
    "Salt-Free Conditioner": {
      "collection": "Salt-Free Conditioners",
      "product": {
        "name": "Salt-Free Water Conditioner",
        "url": "https://crystalquest.com/products/salt-free-water-conditioner"
      }
    },
    "Acid Neutralizer": {
      "collection": "Acid Neutralizers",
      "product": {
        "name": "Acid Neutralizing Whole House Water Filter",
        "url": "https://crystalquest.com/products/acid-neutralizing-whole-house-water-filter"
      }
    },
    "Whole House Reverse Osmosis": {
      "collection": "Whole House Reverse Osmosis",
      "product": {
        "name": "Whole House Reverse Osmosis System",
        "url": "https://crystalquest.com/products/whole-house-reverse-osmosis-system"
      }
    },
    "Alkalizing Remineralization Filter": {
      "collection": "Alkalizing / Remineralization",
      "product": {
        "name": "Natural Alkalizer, Ionizer, Mineralizer & Oxidation Whole House System",
        "url": "https://crystalquest.com/products/natural-alkalizer-ionizer-mineralizer-oxidation"
      }
    },
    "UV Disinfection System": {
      "collection": "UV Systems",
      "product": {
        "name": "Ultraviolet Water Sterilizer System",
        "url": "https://crystalquest.com/products/ultraviolet-water-sterilizer-system"
      }
    },
    "Chlorine Injection System": {
      "collection": "Chemical Dosing Systems",
      "product": {
        "name": "Dosing System",
        "url": "https://crystalquest.com/products/dosing-system"
      }
    },
    "Arsenic Removal System": {
      "collection": "Arsenic Removal",
      "product": {
        "name": "Arsenic Whole House Water Filter",
        "url": "https://crystalquest.com/products/arsenic-whole-house-water-filter"
      }
    },
    "Lead Removal System": {
      "collection": "Lead Removal",
      "product": {
        "name": "Lead Removal Whole House Water Filter",
        "url": "https://crystalquest.com/products/lead-removal-whole-house-water-filter"
      }
    },
    "Mercury Removal System": {
      "collection": "Heavy Metal Removal",
      "product": {
        "name": "Big Blue Whole House Water Filter, SMART Series",
        "url": "https://crystalquest.com/products/big-blue-whole-house-water-filter-smart-series"
      }
    },
    "Hexavalent Chromium Removal": {
      "collection": "Reverse Osmosis (chromium-6)",
      "product": {
        "name": "Whole House Reverse Osmosis System",
        "url": "https://crystalquest.com/products/whole-house-reverse-osmosis-system"
      }
    },
    "Uranium/Radium Removal": {
      "collection": "Radium / Uranium Removal",
      "product": {
        "name": "Radium and Uranium Whole House Water Filter",
        "url": "https://crystalquest.com/products/radium-uranium-whole-house-water-filter"
      }
    },
    "Radionuclide Removal System": {
      "collection": "Radium / Uranium Removal",
      "product": {
        "name": "Radium and Uranium Whole House Water Filter",
        "url": "https://crystalquest.com/products/radium-uranium-whole-house-water-filter"
      }
    },
    "Radon Reduction (GAC)": {
      "collection": "Whole House Water Filters",
      "product": {
        "name": "SMART Whole House Water Filter",
        "url": "https://crystalquest.com/products/smart-whole-house-water-filter"
      }
    },
    "Nitrate Removal System": {
      "collection": "Nitrate Removal",
      "product": {
        "name": "Nitrate Whole House Water Filter",
        "url": "https://crystalquest.com/products/nitrate-whole-house-water-filter"
      }
    },
    "Fluoride Removal System": {
      "collection": "Fluoride Removal",
      "product": {
        "name": "Fluoride Whole House Water Filter",
        "url": "https://crystalquest.com/products/fluoride-whole-house-water-filter"
      }
    },
    "Sulfate Removal System": {
      "collection": "Sulfate Removal",
      "product": {
        "name": "Sulfate Removal Whole House Systems",
        "url": "https://crystalquest.com/products/sulfate-removal-whole-house-systems"
      }
    },
    "Strontium Removal System": {
      "collection": "Ion Exchange / Water Softeners (strontium)",
      "product": {
        "name": "Whole House Water Softener with Pre/Post Filtration",
        "url": "https://crystalquest.com/products/whole-house-water-softener"
      }
    },
    "Barium Removal System": {
      "collection": "Heavy Metal Removal",
      "product": {
        "name": "Metal Removal Whole House Water Filter",
        "url": "https://crystalquest.com/products/iron-whole-house-water-filter"
      }
    },
    "Selenium Removal System": {
      "collection": "Reverse Osmosis (selenium)",
      "product": {
        "name": "Whole House Reverse Osmosis System",
        "url": "https://crystalquest.com/products/whole-house-reverse-osmosis-system"
      }
    },
    "Cadmium Removal System": {
      "collection": "Radium / Cadmium Removal Media",
      "product": {
        "name": "Radium and Cadmium Removal Media",
        "url": "https://crystalquest.com/products/radium-and-cadmium-removal-media"
      }
    },
    "Antimony Removal System": {
      "collection": "Reverse Osmosis (antimony)",
      "product": {
        "name": "Whole House Reverse Osmosis System",
        "url": "https://crystalquest.com/products/whole-house-reverse-osmosis-system"
      }
    },
    "Beryllium Removal System": {
      "collection": "Reverse Osmosis (beryllium)",
      "product": {
        "name": "Whole House Reverse Osmosis System",
        "url": "https://crystalquest.com/products/whole-house-reverse-osmosis-system"
      }
    },
    "Thallium Removal System": {
      "collection": "Reverse Osmosis (thallium)",
      "product": {
        "name": "Whole House Reverse Osmosis System",
        "url": "https://crystalquest.com/products/whole-house-reverse-osmosis-system"
      }
    },
    "Cyanide Removal System": {
      "collection": "Reverse Osmosis (cyanide)",
      "product": {
        "name": "Whole House Reverse Osmosis System",
        "url": "https://crystalquest.com/products/whole-house-reverse-osmosis-system"
      }
    },
    "Tannin Removal System": {
      "collection": "Tannin Removal",
      "product": {
        "name": "Tannin Whole House Water Filter",
        "url": "https://crystalquest.com/products/tannin-whole-house-water-filter"
      }
    },
    "Turbidity/Sediment Filter": {
      "collection": "Turbidity Removal",
      "product": {
        "name": "Turbidity Whole House Water Filter",
        "url": "https://crystalquest.com/products/turbidity-whole-house-water-filter"
      }
    },
    "Perchlorate Removal": {
      "collection": "Reverse Osmosis (perchlorate)",
      "product": {
        "name": "Whole House Reverse Osmosis System",
        "url": "https://crystalquest.com/products/whole-house-reverse-osmosis-system"
      }
    },
    "Silica Treatment System": {
      "collection": "Silica Removal",
      "product": {
        "name": "Silica Whole House Water Filter",
        "url": "https://crystalquest.com/products/silica-whole-house-water-filter"
      }
    },
    "Silica Reduction System (RO Pre-Treatment)": {
      "collection": "Silica Removal",
      "product": {
        "name": "Silica Whole House Water Filter",
        "url": "https://crystalquest.com/products/silica-whole-house-water-filter"
      }
    },
    "TDS Reduction System": {
      "collection": "Reverse Osmosis (TDS)",
      "product": {
        "name": "Whole House Reverse Osmosis System",
        "url": "https://crystalquest.com/products/whole-house-reverse-osmosis-system"
      }
    },
    "Sodium Reduction (RO Required)": {
      "collection": "Reverse Osmosis (sodium)",
      "product": {
        "name": "Whole House Reverse Osmosis System",
        "url": "https://crystalquest.com/products/whole-house-reverse-osmosis-system"
      }
    },
    "Chloride Reduction (RO Required)": {
      "collection": "Reverse Osmosis (chloride)",
      "product": {
        "name": "Whole House Reverse Osmosis System",
        "url": "https://crystalquest.com/products/whole-house-reverse-osmosis-system"
      }
    }
  },
  "PRESENT_PRODUCTS": {
    "smart_wh": {
      "handle": "smart-whole-house-water-filter",
      "name": "SMART Whole House Filter",
      "url": "https://crystalquest.com/products/smart-whole-house-water-filter",
      "blurb": "Our flagship multimedia bed, chlorine, chloramine, VOCs, many PFAS-class chemicals and other common contaminants, with naturally balanced pH.",
      "tier": "standard"
    },
    "eagle_wh": {
      "handle": "eagle-whole-house-water-filter",
      "name": "Eagle Whole House Filter",
      "url": "https://crystalquest.com/products/eagle-whole-house-water-filter",
      "blurb": "Premium multimedia filtration with an alkalizing mineral blend AND a built-in 0.2-micron UF membrane for bacteria/virus protection.",
      "tier": "premium"
    },
    "guardian_wh": {
      "handle": "whole-house-water-filter-guardian",
      "name": "Guardian Whole House Filter",
      "url": "https://crystalquest.com/products/whole-house-water-filter-guardian",
      "blurb": "Set-and-forget 3-stage chlorine reduction with 5-10 year media life. No electricity, lowest cost full-size tank.",
      "tier": "budget"
    },
    "wh_ro": {
      "handle": "whole-house-reverse-osmosis-system",
      "name": "Whole House Reverse Osmosis System",
      "url": "https://crystalquest.com/products/whole-house-reverse-osmosis-system",
      "blurb": "Maximum purity at every tap, the only technology that removes dissolved solids (TDS) house-wide.",
      "tier": "premium"
    },
    "lead_wh": {
      "handle": "lead-removal-whole-house-water-filter",
      "name": "Lead Removal Whole House Filter",
      "url": "https://crystalquest.com/products/lead-removal-whole-house-water-filter",
      "blurb": "Sodium-form ion-exchange resin that captures lead; softens as a side benefit."
    },
    "arsenic_wh": {
      "handle": "arsenic-whole-house-water-filter",
      "name": "Arsenic Whole House Filter",
      "url": "https://crystalquest.com/products/arsenic-whole-house-water-filter",
      "blurb": "Eagle Arsenic Oxide media targeting both arsenic-III and arsenic-V."
    },
    "fluoride_wh": {
      "handle": "fluoride-whole-house-water-filter",
      "name": "Fluoride Whole House Filter",
      "url": "https://crystalquest.com/products/fluoride-whole-house-water-filter",
      "blurb": "Bone-char calcium GAC, the highest-capacity fluoride media CQ sells."
    },
    "nitrate_wh": {
      "handle": "nitrate-whole-house-water-filter",
      "name": "Nitrate Whole House Filter",
      "url": "https://crystalquest.com/products/nitrate-whole-house-water-filter",
      "blurb": "Anion-exchange nitrate resin (brine-regenerated). Critical for infants and pregnancy."
    },
    "iron_wh": {
      "handle": "iron-whole-house-water-filter",
      "name": "Metal Removal Whole House Filter",
      "url": "https://crystalquest.com/products/iron-whole-house-water-filter",
      "blurb": "The well-water workhorse for iron, manganese and rotten-egg hydrogen sulfide."
    },
    "tannin_wh": {
      "handle": "tannin-whole-house-water-filter",
      "name": "Tannin Whole House Filter",
      "url": "https://crystalquest.com/products/tannin-whole-house-water-filter",
      "blurb": "Clears yellow/brown organic color from swampy or wooded watersheds."
    },
    "silica_wh": {
      "handle": "silica-whole-house-water-filter",
      "name": "Silica Whole House Filter",
      "url": "https://crystalquest.com/products/silica-whole-house-water-filter",
      "blurb": "TrappXT silica media for the white glass-etching scale softeners can't fix."
    },
    "radium_wh": {
      "handle": "radium-uranium-whole-house-water-filter",
      "name": "Radium & Uranium Whole House Filter",
      "url": "https://crystalquest.com/products/radium-uranium-whole-house-water-filter",
      "blurb": "Radionuclide-selective media for granite-bedrock and mining regions."
    },
    "sulfate_wh": {
      "handle": "sulfate-removal-whole-house-systems",
      "name": "Sulfate Removal Whole House System",
      "url": "https://crystalquest.com/products/sulfate-removal-whole-house-systems",
      "blurb": "Anion-exchange sulfate removal (brine-regenerated)."
    },
    "acid_wh": {
      "handle": "acid-neutralizing-whole-house-water-filter",
      "name": "Acid Neutralizing Whole House Filter",
      "url": "https://crystalquest.com/products/acid-neutralizing-whole-house-water-filter",
      "blurb": "Calcite bed raises corrosive low pH (often bundled with a softener)."
    },
    "softener": {
      "handle": "whole-house-water-softener",
      "name": "Whole House Water Softener",
      "url": "https://crystalquest.com/products/whole-house-water-softener",
      "blurb": "True cation-exchange softening, soap lather, appliance protection."
    },
    "saltfree": {
      "handle": "salt-free-water-conditioner",
      "name": "Salt-Free Water Conditioner",
      "url": "https://crystalquest.com/products/salt-free-water-conditioner",
      "blurb": "Anti-scale conditioning with zero salt, drain or electricity, keeps healthy minerals."
    },
    "highflow": {
      "handle": "high-flow-whole-house-water-filter",
      "name": "High Flow Whole House Filter",
      "url": "https://crystalquest.com/products/high-flow-whole-house-water-filter",
      "blurb": "15-35 GPM for 5+ bathroom homes and estates."
    },
    "uv": {
      "handle": "ultraviolet-water-sterilizer-system",
      "name": "UV Water Sterilizer",
      "url": "https://crystalquest.com/products/ultraviolet-water-sterilizer-system",
      "blurb": "99.99% bacteria & virus disinfection, always after filtration."
    },
    "oxiorg": {
      "handle": "dosing-system",
      "name": "Chemical Dosing Pre-Treatment",
      "url": "https://crystalquest.com/products/dosing-system",
      "blurb": "Metered dosing pre-treatment that oxidizes heavy iron loads ahead of filtration."
    },
    "thunder": {
      "handle": "reverse-osmosis-under-sink-water-filter-1000c",
      "name": "Thunder Under-Sink RO",
      "url": "https://crystalquest.com/products/reverse-osmosis-under-sink-water-filter-1000c",
      "blurb": "12-stage under-sink reverse osmosis for pure drinking water at the tap."
    },
    "thunder_uv": {
      "handle": "reverse-osmosis-under-sink-water-filter-4000c",
      "name": "Thunder 4000 Under-Sink RO + UV",
      "url": "https://crystalquest.com/products/reverse-osmosis-under-sink-water-filter-4000c",
      "blurb": "Under-sink RO with UV disinfection and a final UF polish capsule, microbial security at the tap."
    },
    "smart_ct": {
      "handle": "smart-countertop-water-filter-system",
      "name": "SMART Countertop Filter",
      "url": "https://crystalquest.com/products/smart-countertop-water-filter-system",
      "blurb": "No-plumbing countertop filtration for renters and small budgets."
    },
    "turbidity_wh": {
      "handle": "turbidity-whole-house-water-filter",
      "name": "Turbidity Reduction Whole House Filter",
      "url": "https://crystalquest.com/products/turbidity-whole-house-water-filter",
      "blurb": "Staged sediment filtration that clears cloudy, gritty water ahead of everything else."
    },
    "smart_us": {
      "handle": "smart-under-sink-water-filter-system",
      "name": "SMART Under-Sink Filter",
      "url": "https://crystalquest.com/products/smart-under-sink-water-filter-system",
      "blurb": "Multimedia under-sink polish for taste and everyday chemistry, no membrane or drain line."
    },
    "remin_wh": {
      "handle": "big-blue-whole-house-water-filter-eagle-series",
      "name": "Big Blue Alkalizing Filter",
      "url": "https://crystalquest.com/products/big-blue-whole-house-water-filter-eagle-series",
      "blurb": "Single-cartridge alkalizing remineralizer installed after reverse osmosis."
    }
  }
};
if (typeof module !== 'undefined') { module.exports = ENGINE_DATA; }
